import PropTypes from 'prop-types';

import Box from '@zenbusiness/zui/Box';
import Button from '@zenbusiness/zui/Button';

import { CLICKSTREAM_COMMON_PROPS } from '../utils/constants';
import VeloAvatar from '../VeloAvatar';

/**
 * ChatErrorMessage Component
 *
 * This component was used when the backend sent an error message directly,
 * but they are handled by the UI now, so it is not actually used.
 *
 * Shows an error message at the bottom of the chat with retry options
 *
 * @param {object} props - Component props
 * @param {Function} props.onRetry - Handler for retry button
 * @param {Function} props.onStartNew - Handler for start new conversation button
 * @param {boolean} [props.loading] - Whether a retry operation is in progress
 * @returns {import('react').ReactElement} The ChatErrorMessage component
 */
function ChatErrorMessage({ onRetry, onStartNew, loading = false }) {
  const clickstreamRetryProps = {
    ...CLICKSTREAM_COMMON_PROPS,
    elementName: 'retry_last_message',
    elementText: 'Retry last message'
  };

  const clickstreamStartNewProps = {
    ...CLICKSTREAM_COMMON_PROPS,
    elementName: 'create_new_chat',
    elementText: 'Create new chat'
  };

  return (
    <Box alignItems="flex-end" display="flex" flexDirection="row" gap={1}>
      <VeloAvatar height={50} state="warning" width={50} />
      <Button
        clickstreamProps={clickstreamRetryProps}
        color="primary"
        disabled={loading}
        variant="contained"
        onClick={onRetry}
      >
        {loading ? 'Retrying...' : 'Retry Last Message'}
      </Button>
      <Button
        clickstreamProps={clickstreamStartNewProps}
        color="primary"
        disabled={loading}
        variant="outlined"
        onClick={onStartNew}
      >
        Start New Chat
      </Button>
    </Box>
  );
}

ChatErrorMessage.propTypes = {
  onRetry: PropTypes.func.isRequired,
  onStartNew: PropTypes.func.isRequired,
  loading: PropTypes.bool
};

export default ChatErrorMessage;
